import { createSlice } from "@reduxjs/toolkit";
import { userNonprofitListAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const userNonprofitSlice = createSlice({
  name: "userNonprofit",
  initialState: data,
  reducers: {
    userNonprofitSlice(state) {
      state.isLoading = true;
    },
    userNonprofitSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    userNonprofitSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    userNonprofitSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const userNonprofitHandler = () => async (dispatch: any) => {
  try {
    dispatch(userNonprofitAction.userNonprofitSlice());
    const response: any = await userNonprofitListAPI();
    dispatch(userNonprofitAction.userNonprofitSliceSuccess(response));
  } catch (e: any) {
    dispatch(userNonprofitAction.userNonprofitSliceFailure(e?.response?.data?.message));
    dispatch(userNonprofitAction.userNonprofitSliceReset());
  }
};
export default userNonprofitSlice.reducer;
export const userNonprofitAction = userNonprofitSlice.actions;
